import React from 'react';
import styled, { css } from 'styled-components';
import { getDateTime, isSameDate, isToday } from '../../services/date.service';

interface EventPickerDayProps extends React.AllHTMLAttributes<HTMLElement> {
  isCurrentMonth: boolean;
  date: Date;
  selectDate: Date;
  handleClick?: Function;
  isEmpty?: boolean;
}

const StyledEventNotifications = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const StyledText = styled.span`
  display: block;
  margin: 0;
  font-size: 14px;
  line-height: 20px;
`;
const isTodayStyled = css`
  ${StyledText} {
    background: ${({ theme }) => theme.colors.BLUE.B400};
    color: ${({ theme }) => theme.colors.NEUTRAL.N0};
  }
`;
const isEmptyStyled = css`
  ${StyledText} {
    background: ${({ theme }) => theme.colors.NEUTRAL.N0};
  }
`;
const isNotSelectedMonthStyled = css`
  ${StyledText} {
    background: ${({ theme }) => theme.colors.NEUTRAL.N100};
  }
`;

const isNotCurrentMonthStyle = css`
  color: ${({ theme }) => theme.colors.NEUTRAL.N600};
`;
export const StyledDatePickerDay = styled.div<{
  isCurrentMonth: boolean;
  isToday: boolean;
  selectedDate: boolean;
  isEmpty?: boolean;
}>`
  position: relative;
  min-height: 200px;
  min-width: 200px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.NEUTRAL.N300};
  border-left: 1px solid ${({ theme }) => theme.colors.NEUTRAL.N300};
  background-color: ${({ theme, isCurrentMonth }) =>
    isCurrentMonth ? theme.colors.NEUTRAL.N0 : theme.colors.NEUTRAL.N100};
  padding: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:first-child,
  &:nth-child(7n + 1) {
    border-left: none;
  }

  ${StyledText} {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border-radius: 100px;
    background: ${({ theme, isCurrentMonth }) =>
      isCurrentMonth ? theme.colors.NEUTRAL.N100 : theme.colors.NEUTRAL.N300};
    margin: 0 0 15px;
  }

  ${props => props.isEmpty && props.isCurrentMonth && isEmptyStyled};
  ${props => props.isEmpty && !props.isCurrentMonth && isNotSelectedMonthStyled};
  ${props => props.isToday && isTodayStyled};

  ${props =>
    (!props.isCurrentMonth || props.isEmpty) && isNotCurrentMonthStyle};
`;

const EventDayComponent = ({
  handleClick,
  isCurrentMonth,
  date,
  selectDate,
  isEmpty,
  children,
}: EventPickerDayProps) => {
  const day = getDateTime(date, 'D');
  const selectedDate = isSameDate(date, selectDate);

  const handleClickDay = () => {
    handleClick && handleClick(date);
  };

  return (
    <StyledDatePickerDay
      isToday={isToday(date)}
      selectedDate={selectedDate}
      isCurrentMonth={isCurrentMonth}
      onClick={handleClickDay}
      isEmpty={isEmpty}
      className="event-day"
    >
      <StyledText className="day-name">{day}</StyledText>
      <StyledEventNotifications className="event-list">
        {children}
      </StyledEventNotifications>
    </StyledDatePickerDay>
  );
};

export default EventDayComponent;
